import { QueryClient, MutationCache } from '@tanstack/react-query';
import { notifyApiError } from './api-error';

export const queryClient = new QueryClient({
  // Surface unhandled mutation failures globally as a friendly toast. Mutations
  // that define their own onError opt out automatically (prevents double toasts).
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation.options.onError) return;
      notifyApiError(error);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
